/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Guide_Language_Select_PlaceholderInputs */

const en_knp_guide_language_select_placeholder = /** @type {(inputs: Knp_Guide_Language_Select_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-- Select a language --`)
};

const fr_knp_guide_language_select_placeholder = /** @type {(inputs: Knp_Guide_Language_Select_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-- Sélectionner une langue --`)
};

const de_knp_guide_language_select_placeholder = /** @type {(inputs: Knp_Guide_Language_Select_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-- Wählen Sie eine Sprache --`)
};

const it_knp_guide_language_select_placeholder = /** @type {(inputs: Knp_Guide_Language_Select_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-- Seleziona una lingua --`)
};

const ru_knp_guide_language_select_placeholder = /** @type {(inputs: Knp_Guide_Language_Select_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-- Выберите язык --`)
};

const es_knp_guide_language_select_placeholder = /** @type {(inputs: Knp_Guide_Language_Select_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-- Seleccione un idioma --`)
};

const zh_cn2_knp_guide_language_select_placeholder = /** @type {(inputs: Knp_Guide_Language_Select_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-- 选择语言 --`)
};

const ja_knp_guide_language_select_placeholder = /** @type {(inputs: Knp_Guide_Language_Select_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-- 言語を選択 --`)
};

const hi_knp_guide_language_select_placeholder = /** @type {(inputs: Knp_Guide_Language_Select_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-- भाषा चुनें --`)
};

const pt_pt2_knp_guide_language_select_placeholder = /** @type {(inputs: Knp_Guide_Language_Select_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-- Selecione um idioma --`)
};

/**
* | output |
* | --- |
* | "-- Select a language --" |
*
* @param {Knp_Guide_Language_Select_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_guide_language_select_placeholder = /** @type {((inputs?: Knp_Guide_Language_Select_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Guide_Language_Select_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_guide_language_select_placeholder(inputs)
	if (locale === "de") return de_knp_guide_language_select_placeholder(inputs)
	if (locale === "it") return it_knp_guide_language_select_placeholder(inputs)
	if (locale === "ru") return ru_knp_guide_language_select_placeholder(inputs)
	if (locale === "es") return es_knp_guide_language_select_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_guide_language_select_placeholder(inputs)
	if (locale === "ja") return ja_knp_guide_language_select_placeholder(inputs)
	if (locale === "hi") return hi_knp_guide_language_select_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_guide_language_select_placeholder(inputs)
	return en_knp_guide_language_select_placeholder(inputs)
});